<template>
  <aside class="app-sidebar" id="sidebar" v-bind:class="{ active: isSidebarActive }">
    <div class="sidebar-header">
      <router-link :to="{name: 'UserProfile'}" class="sidebar-brand">
        <div class="highlight"><img src="/static/images/lawfluent-logo-horizontal.png" /></div>
        <div class="app-name">Identity</div>
      </router-link>
      <button type="button" class="sidebar-toggle" @click="toggleSidebarNav()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul class="sidebar-nav">
        <li :class="{'active': isDashboard}">
          <router-link :to="{name: 'Dashboard'}">
            <div class="icon">
              <i class="fa fa-tachometer" aria-hidden="true"></i>
            </div>
            <div class="title">Dashboard</div>
          </router-link>
        </li>
        <li :class="{'active': isUserSettings}">
          <router-link :to="{name: 'UserProfile'}">
            <div class="icon">
              <i class="fa fa fa-cog" aria-hidden="true"></i>
            </div>
            <div class="title">User Settings</div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="sidebar-footer">
      <ul class="menu">
        <li>
          <a>
            <span>Law Fluent</span>
            <span class="fa fa-copyright"></span>
            <span>
              {{currentYear}}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>
<script>
import NavMixin from './NavMixin'
export default {
  mixins: [NavMixin],
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    },
    isDashboard: function () {
      return this.$route.path.startsWith('/id/dashboard')
    },
    isUserSettings: function () {
      return this.$route.path.startsWith('/id/user-profile')
    }
  }
}
</script>
